import { render, staticRenderFns } from "./PaymentErrorModal.vue?vue&type=template&id=3a67b37c&scoped=true&"
import script from "./PaymentErrorModal.vue?vue&type=script&lang=js&"
export * from "./PaymentErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67b37c",
  null
  
)

export default component.exports